export default [
  {
    path: '/login',
    component: () => import('@/views/single/Login'),
  },
  {
    path: '/invoice_detail/:invoiceSeq/:lang',
    component: () => import('@/views/single/InvoiceDetail'),
    props: true,
  },
  {
    path: '/invoice_detail/:invoiceSeq',
    component: () => import('@/views/single/InvoiceDetail'),
    props: true,
  },
  {
    path: '/:userSeq/invoice_detail/:invoiceSeq/:lang',
    component: () => import('@/views/single/InvoiceDetail'),
    props: true,
  },
  {
    path: '/error/:error',
    component: () => import('@/views/single/Error'),
  },
  {
    path: '*',
    component: () => import('@/views/single/Error'),
  },
]
